import {ReportDeliveryStatus} from "@/enums/status";
import moment from "moment";

export class ReportDeliveryParams {
    page = 1;
    limit = 10;
    ladingCode?: string;
    deliveryPostOfficeRowGuid?: string;
    employeeRowGuid?: string;
    partnerRowGuid?: string;
    customerRowGuid?: string;
    status = ReportDeliveryStatus.PHAT_THANH_CONG;
    fromDate? = moment().startOf('month').valueOf();
    toDate? = moment().valueOf();
}
